import {
  Archive,
  Code2,
  Combine,
  Crop,
  Eraser,
  FileCode2,
  FileImage,
  FileOutput,
  FilePenLine,
  FileScan,
  FileSpreadsheet,
  FileText,
  Files,
  FileType2,
  GitCompareArrows,
  Grid2X2Plus,
  Hash,
  Images,
  Languages,
  LayoutDashboard,
  ListChecks,
  LockKeyhole,
  LockKeyholeOpen,
  Minimize2,
  NotebookTabs,
  Presentation,
  RotateCw,
  ScanLine,
  ScanText,
  Scissors,
  ShieldCheck,
  Signature,
  Sparkles,
  Stamp,
  Table2,
  Wrench,
  type LucideIcon,
} from 'lucide-react';
import type { ProcessorId, ToolCategoryId } from '../domain/tools/types';

const icons: Record<ProcessorId, LucideIcon> = {
  merge: Combine,
  split: Scissors,
  'remove-pages': FileOutput,
  'extract-pages': Files,
  organize: Grid2X2Plus,
  scan: ScanLine,
  compress: Minimize2,
  repair: Wrench,
  ocr: ScanText,
  'images-to-pdf': Images,
  'docx-to-pdf': FileType2,
  'pptx-to-pdf': Presentation,
  'xlsx-to-pdf': FileSpreadsheet,
  'html-to-pdf': Code2,
  'pdf-to-images': FileImage,
  'pdf-to-docx': FileText,
  'pdf-to-pptx': NotebookTabs,
  'pdf-to-xlsx': Table2,
  'pdf-to-pdfa': Archive,
  rotate: RotateCw,
  'page-numbers': Hash,
  watermark: Stamp,
  crop: Crop,
  'edit-overlay': FilePenLine,
  forms: ListChecks,
  unlock: LockKeyholeOpen,
  protect: LockKeyhole,
  sign: Signature,
  redact: Eraser,
  compare: GitCompareArrows,
  summarize: Sparkles,
  translate: Languages,
  'pdf-to-markdown': FileCode2,
};

const categoryIcons: Record<ToolCategoryId, LucideIcon> = {
  organize: LayoutDashboard,
  optimize: Minimize2,
  toPdf: FileOutput,
  fromPdf: FileScan,
  edit: FilePenLine,
  security: ShieldCheck,
  intelligence: Sparkles,
};

interface ToolIconProps {
  readonly tool?: ProcessorId;
  readonly category?: ToolCategoryId;
  readonly size?: number;
}

export function ToolIcon({ tool, category, size = 21 }: ToolIconProps) {
  const Icon = tool ? icons[tool] : category ? categoryIcons[category] : FileText;
  return <Icon aria-hidden="true" size={size} strokeWidth={1.85} />;
}
